$(document).ready(function() {

	if ($(window).width() <= 767) {
		$('.topws').appendTo('.header-panel-top ul');
		$('.appcry').appendTo('.header-panel-top ul');
	};

	if ($(window).width() <= 991) {
		$('.wbhm').appendTo('.wbmenuapp');
	};
  
	// Sticky Header
  	if ($(document).width() >= 992){
    $(window).scroll(function () {
        if ($(this).scrollTop() > 165) {
            $('.headernav').addClass('fixed fadeInDown animated');
        } else {
            $('.headernav').removeClass('fixed fadeInDown animated');
        }
    });
    };

	// Slider
	$('.owl-slider').slick({
		dots: true,
		arrows: false,
		infinite: false,
		autoplay: false,
		autoplaySpeed: 2000,
		slidesToShow: 1,
		slidesToScroll: 1
    });

	// Product Carousel
    $(".owl-fea,.owl-latest,.owl-best,.owl-topr,.related-products").owlCarousel({
    itemsCustom : [
    [0, 1],
    [320, 2],
    [600, 3],
    [768, 3],
    [992, 3],
    [1200, 4],
    [1410, 4]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation: true,
    pagination:false
    });

    $(".owl-spe").owlCarousel({
    itemsCustom : [
    [0, 1],
    [320, 1],
    [440, 2],
    [600, 1],
    [768, 1]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation: true,
    pagination:false
    });
  
    $(".owl-prop1,.owl-prop2,.owl-prop3").owlCarousel({
    itemsCustom : [
    [0, 1],
    [320, 1],
    [600, 2],
    [768, 2],
    [992, 1]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation: false,
    pagination:false
    });


    $(".owlblog").owlCarousel({
    itemsCustom : [
	[0, 1],
	[600, 2],
	[768, 1],
	[992, 2],
	[1200, 2],
	[1410, 2]
    ],
    // autoPlay: 1000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : true,
    pagination:false
    });

    // Megamenu Product
    $("#owl-menuproduct").owlCarousel({
    itemsCustom : [
	[0, 1],
	[600, 2],
	[768, 2],
	[992, 2],
	[1200, 2],
	[1590, 3]
    ],
    autoPlay: 3000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : false,
    pagination:false
    });

    // Megamenu Blog
    $(".owl-wbmegablog").owlCarousel({
    itemsCustom : [
	[0, 1],
	[600, 2],
	[768, 2],
	[992, 3],
	[1200, 4],
	[1410, 5]
    ],
    autoPlay: 3000,
    navigationText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
    navigation : false,
    pagination:false
    });

    // Mobile Menu Toggle
    if ($(window).width() <= 991) {
	    $('.wbmegamainhd').on('click', function() {
	        var targetMenu = '#' + $(this).data('submenu');
	        $(targetMenu).slideToggle(300);
	        $(this).toggleClass('active');
	        return false;
	    });
	};
  
  	// Popup Product
    $('.wbpopup-popducts .popinner').hide();
    var i = 0;
    setIntervalFun();
    var totalTimer = parseInt(3000) + parseInt(2000);
    setInterval( setIntervalFun, totalTimer);
    function setIntervalFun()
    {
        $('.wbpopup-popducts .popinner').eq(i).fadeIn(400);
        setTimeout(function(){
            $('.wbpopup-popducts .popinner').eq(i).fadeOut(400);
            i++;
            if ($('.wbpopup-popducts .popinner').length <= i) {
                i = 0;
            }
        },parseInt(7000));
    }
    $(document).on('click', '.wbclosepopup', function(){
        $('.wbpopup-popducts').fadeOut(400).remove();
    });

    // Box Layout
    $(".wbboxdemo").click(function(){
        $(".wbboxlt").attr("id","wbboxlayout");
    });
    $(".wbwidedemo").click(function(){
        $(".wbboxlt").removeAttr("id");
    }); 
    // Color Customizer
    $("body").on("click", ".wbinnerclr a", function(e){
    e.preventDefault();
    $('.wbinnerclr').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbcolorname=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("head").append('<link rel="stylesheet" type="text/css" wbcolorname href="' + $(this).attr('href') + '">');
    });
    // Rtl Mode
    $("body").on("click", ".wbrtlmode a", function(e){
    e.preventDefault();
    $('.wbrtlmode').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbrtl=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("head").append('<link rel="stylesheet" type="text/css" wbrtl href="' + $(this).attr('href') + '">');
    });
    // Color Open/Close 
    $('.wbopen-closeclr').click(function() {
        if ($(this).hasClass('wbclrdisable')) {
            $(this).removeClass('wbclrdisable');
            $(this).addClass('wbclrenable');
            $('.wbcolor_box').animate({right: '30px'}, 450);
            $('.wbcolor_box').css({'box-shadow': '0 10px 35px 10px rgba(0,0,0,.06)', 'background': '#fff', 'border-radius': '4px 0 4px 4px'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '1'}, 450);
        } else {
            $(this).removeClass('wbclrenable');
            $(this).addClass('wbclrdisable');
            $('.wbcolor_box').animate({right: '-250px'}, 450);
            $('.wbcolor_box').css({'box-shadow': 'none', 'background': 'transparent'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '0'}, 450);
        }
    });

});  // Document Ready End

$(window).load(function myFunction() {
  $(".s-panel .loader").removeClass("wrloader");
});

// Menu For Mobile
function w3_open() {
    document.getElementById("myOverlay").style.display = "block";
    document.getElementById("megamenu").className = "active menu-fixed";
    $('body').addClass("wbbodyscroll");
}
function w3_close() {
    document.getElementById("myOverlay").style.display = "none";
    document.getElementById("megamenu").className = "menu-fixed";
    $('body').removeClass("wbbodyscroll");
}

// Search Toggle
function openSearch() {
    $('body').addClass("active-search");
    $('#search').addClass("sideb");
    $('.search_query').attr('autofocus', 'autofocus').focus();
}
function closeSearch() {    
    $('body').removeClass("active-search");
    $('.search_query').attr('autofocus', 'autofocus').focus();
}